import React from "react";
import { Link } from "react-router-dom";

export default function Index() {
  return (
    <div className="sitemap">
      <div className="container">
        <h5>Site Map</h5>
        <ul>
          {
            pages.map(item => (
              <>
                <li><Link to={item.link}>{item.title}</Link></li>
                {item.children ? <ul>
                  {item.children.map(child => (
                    <li><Link to={child.link}>{child.title}</Link></li>
                  ))}
                </ul>
                  : null
                }
              </>
            ))
          }
        </ul>
      </div>
    </div>
  );
}

const pages = [
  { title: "Home page", link: "/" },
  {
    title: "Features", link: "/features-business", children: [
      {
        title: "Features-Consumer", link: "/features-consumer"
      },
      {
        title: "Features-Business", link: "/features-business"
      },
    ]
  },
  { title: "Software Solution", link: "/software-solution" },
  { title: "Acquire New Customers", link: "/acquire-new-customers" },
  { title: "Own Your Online Brand", link: "/own-your-online-brand" },
  { title: "Automate Your Ordering Process", link: "/automate-order-process" },
  { title: "Use Case- Restaurant Ordering", link: "/use-case-restaurant-ordering-solution" },
  { title: "Use Case- Dining Automation", link: "/use-case-dining-automation" },
  { title: "Use Case- Hotel Service Automation", link: "/use-case-hotel-service-automation" },
  { title: "Use Case- Retail Store", link: "/use-case-retail-store-automation" },
  { title: "Use Case- Movie Theatre", link: "/use-case-movie-theatre-ordering" },
  { title: "Use Case- Casino Food/Drink Automation", link: "/use-case-casino-food-drink-automation" },
  { title: "Merchant Service", link: "/merchant-service" },
  { title: "Pos Devices- Clover Flex", link: "/pos-device-clover-flex" },
  { title: "Pos Devices- Clover Mini", link: "/pos-device-clover-flex" },
  { title: "Pos Devices- Clover Station Duo", link: "/pos-device-clover-clover-station-duo" },
  { title: "Pos Devices- Clover Station Solo", link: "/pos-device-clover-station-solo" },
  { title: "Pos Devices- Kitchen Display System", link: "/pos-device-kitchen-display-system" },
  { title: "Pos Devices- Self Service Kiosk", link: "/pos-device-self-service-kiosk" },
  { title: "Hardware Solution", link: "/hardware-solutions" },
  { title: "BellaBot", link: "/bellabot-restaurant-delivery-robot" },
  { title: "FlashBot", link: "/flashbot-building-delivery-robot" },
  { title: "PromoBot", link: "/promobot-promotional-delivery-robot" },
  { title: "PuduBot", link: "/pudubot-food-delivery-robot" },
  { title: "Disinfection Bot", link: "/disinfectionbot-autonomous-disinfection-robot" },
  { title: "Pricing", link: "/pricing" },
  { title: "Request a demo", link: "/request-a-demo" },
  { title: "Request a demo after submission", link: "/request-a-demo" },
  { title: "Contact Us", link: "/contact-us" },
  { title: "About Us", link: "/about-us" },
  { title: "FAQ", link: "/faq" },
  { title: "Careers", link: "/careers" },
  { title: "Sign up page", link: "/signup" },
];
